import { useContext } from 'react'

import { PageContext } from '@pages/EntityCreateOrEdit'

import { useCreateColumnViewMutation, useUpdateColumnViewMutation } from '@redux/api'

import { MODEL_TYPE } from '@constants'
import { PayloadCreateViewColumn } from '@types'

import { AddColumnDialog } from '../AddColumnDialog'

export const AddViewColumnDialog = () => {
  const {
    onCloseModal,
    showDialog,
    modalType,
    rawObjectFields,
    mainTable: { rows: columns },
    currentRow,
    objectCode,
    objectCommands,
    bindingValuesColumns,
    entityCode,
    currentEntity,
    onSetModalProperty,
    entityFormCode,
    actionTable,
    entityType,
  } = useContext(PageContext)

  const [createColumn, { isLoading: isLoadingCreateColumn }] = useCreateColumnViewMutation()
  const [updateColumn, { isLoading: isLoadingUpdateColumn }] = useUpdateColumnViewMutation()

  const handleCreateColumn = (data: PayloadCreateViewColumn) => {
    if (isLoadingCreateColumn) return

    return createColumn(data).unwrap()
  }

  const handleUpdateColumn = (data: PayloadCreateViewColumn) => {
    if (isLoadingUpdateColumn) return

    return updateColumn(data).unwrap()
  }

  return (
    <AddColumnDialog
      actionTable={actionTable}
      bindingValuesColumns={bindingValuesColumns}
      columns={columns}
      currentEntity={currentEntity}
      currentRow={currentRow}
      entityCode={entityCode}
      entityFormCode={entityFormCode}
      entityType={entityType}
      modalType={modalType}
      objectCode={objectCode}
      objectCommands={objectCommands}
      rawObjectFields={rawObjectFields}
      showDialog={showDialog}
      type={MODEL_TYPE.VIEW}
      onCloseModal={onCloseModal}
      onCreateColumn={handleCreateColumn}
      onSetModalProperty={onSetModalProperty}
      onUpdateColumn={handleUpdateColumn}
      loading={isLoadingCreateColumn || isLoadingUpdateColumn}
    />
  )
}
